import { cgw, consumerTrackingApi } from '../lib'
import { getConsumerGatewayBasicAuth } from './headers'

export enum GrantType {
  AUTHORIZATION_CODE = 'authorization_code',
}

export enum AuthenticationMethod {
  ORDER_CHECK = 'order-check',
}

export interface AuthenticatePayload {
  grant_type: GrantType
  authentication_method: AuthenticationMethod
  code: string
  hint: string
}

interface AuthenticateProps {
  id: string
  authCode: string
}

interface GetAuthCodeProps {
  email?: string
  id: string
  phoneNumber?: string
}

export async function authenticate({ id, authCode }: AuthenticateProps) {
  const payload: AuthenticatePayload = {
    grant_type: GrantType.AUTHORIZATION_CODE,
    code: authCode,
    authentication_method: AuthenticationMethod.ORDER_CHECK,
    hint: id,
  }

  return cgw.request({
    method: 'POST',
    url: '/oauth/token',
    auth: getConsumerGatewayBasicAuth(),
    data: payload,
  })
}

/**
 * This function can be used to get the auth code for an order.
 * We can search by either email or phone number
 */
export async function getAuthCode({ email, id, phoneNumber }: GetAuthCodeProps) {
  return consumerTrackingApi.request({
    method: 'POST',
    url: '/public/order-search',
    data: { email, phoneNumber, trackingId: id },
  })
}
